import styled, { css } from 'styled-components';
import { space } from 'styled-system';

const OptionListItemStyles = styled.option``;

const OptionListStyles = styled.select`
  ${space}

  border: 0.0625rem solid ${props => props.theme.colors.inputBorder};
  height: ${props => props.theme.buttonSize.normal};
  line-height: ${props => props.theme.buttonSize.normal};
  padding-left: ${props => props.theme.space[1]};
  padding-right: ${props => props.theme.space[1]};

  ${props =>
    props.fullWidth &&
    css`
      width: 100%;
    `};
`;

OptionListStyles.ItemStyles = OptionListItemStyles;

export default OptionListStyles;
